import './Footer.css';

function Footer() {
  return (
    <som-footer light={false}>
    </som-footer>
  );
}

export default Footer;